import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "form-filter-container flex" }
const _hoisted_2 = { class: "aud-counter" }

import { ref, computed } from "vue";
import { useRoute } from "vue-router";
import { useAuthStore } from "@/store/auth/login";

import InnerPageLayout from "@/widgets/layouts/InnerPageLayout.vue";
import TopSegmentPanel from "@/entities/segments/panels/TopSegmentPanel.vue";
import SegmentCreateForm from "@/entities/segments/forms/SegmentCreateForm.vue";
import SegmentCountersWrapper from "@/widgets/counters/SegmentCountersWrapper.vue";
import HandlerAccessDenied from "@/shared/base/HandlerAccessDenied.vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'SegmentPage',
  setup(__props) {

const isCreateButtonEnabled = ref(false);
const isLoading = ref(false);
const filter = ref(null);
const createFormRef = ref<InstanceType<typeof SegmentCreateForm> | null>(null);
const audienceCount = ref<number | null>(null);
const segmentCost = ref<number | null>(null);
const isReadyToCount = ref(false);
const countDisabledReason = ref<string | null>(null);
const authStore = useAuthStore();
const route = useRoute();

const isDenied = computed(() => {
  if (route.params && route.params.id)
    return authStore.isDeniedForPermissions([
      "segment:read",
      "segment:edit",
      "system:read",
      "system:edit",
    ]);

  return authStore.isDeniedForPermissions(["segment:edit", "system:edit"]);
});

const setCreateButton = (value: any) => {
  isCreateButtonEnabled.value = value.value;
};

const setLoading = (value: boolean) => {
  isLoading.value = value;
};

const updateFilter = (formFilter: any) => {
  filter.value = formFilter;
};

const createSegment = () => {
  if (createFormRef.value) createFormRef.value.createSegment();
};

const updateIsReadyToCount = (value: boolean) => {
  isReadyToCount.value = value;
};

const updateCountDisabledReason = (reason: string | null) => {
  countDisabledReason.value = reason;
};

const updateAudienceCount = (count: number) => {
  audienceCount.value = count;
};

const updateSegmentCost = (cost: number) => {
  segmentCost.value = cost;
};

const isSegmentSetted = computed(() => {
  return Boolean(route.params.id);
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(InnerPageLayout, null, {
    default: _withCtx(() => [
      _createVNode(HandlerAccessDenied, { "is-denied": isDenied.value }, {
        default: _withCtx(() => [
          _createVNode(TopSegmentPanel, {
            isCreateButtonEnabled: isCreateButtonEnabled.value,
            isLoading: isLoading.value,
            isSegmentSetted: isSegmentSetted.value,
            onCreateSegment: createSegment
          }, null, 8, ["isCreateButtonEnabled", "isLoading", "isSegmentSetted"]),
          _createElementVNode("div", _hoisted_1, [
            _createVNode(SegmentCreateForm, {
              isLoading: isLoading.value,
              audienceCount: audienceCount.value,
              segmentCost: segmentCost.value,
              onSetCreateButton: setCreateButton,
              onSetLoading: setLoading,
              onSetFilter: updateFilter,
              onUpdateIsReadyToCount: updateIsReadyToCount,
              onUpdateCountDisabledReason: updateCountDisabledReason,
              onUpdateAudienceCount: updateAudienceCount,
              onUpdateSegmentCost: updateSegmentCost,
              ref_key: "createFormRef",
              ref: createFormRef
            }, null, 8, ["isLoading", "audienceCount", "segmentCost"]),
            _createElementVNode("div", _hoisted_2, [
              _createVNode(SegmentCountersWrapper, {
                filter: filter.value,
                "setted-audience-count": audienceCount.value,
                "setted-segment-cost": segmentCost.value,
                "is-ready-to-count": isReadyToCount.value,
                "count-disabled-reason": countDisabledReason.value,
                "is-segment-setted": isSegmentSetted.value,
                onUpdateAudienceCount: updateAudienceCount,
                onUpdateSegmentCost: updateSegmentCost
              }, null, 8, ["filter", "setted-audience-count", "setted-segment-cost", "is-ready-to-count", "count-disabled-reason", "is-segment-setted"])
            ])
          ])
        ]),
        _: 1
      }, 8, ["is-denied"])
    ]),
    _: 1
  }))
}
}

})